import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";
import { flex } from "Utils/Styles";

const classNames = {
  root: `ProjectCount`
};

export function useProjectCountStyles() {
  const { fonts, semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          ...flex,
          ...fonts.small,
          justifyContent: `center`,
          color: semanticColors.disabledText,
          textAlign: `center`,
          width: `25%`
        }
      ]
    }),
    [fonts, semanticColors]
  );
}
